import React, { useMemo } from 'react'
import { Modal } from 'antd'
import { FiMessageSquare } from 'react-icons/fi'
import {
  useFeedbackModal,
  getRecommendationDisplayName
} from '../hooks/useFeedbackModal'
import FeedbackQuestionStep from './FeedbackQuestionStep'
import StepIndicator from './StepIndicator'
import ModalFooter from './ModalFooter'
import styles from './FeedbackModal.module.css'

const FeedbackModal = ({
  person,
  arDetail,
  recommendationType,
  buttonText = 'Share feedback'
}) => {
  const feedbackModal = useFeedbackModal(person, arDetail)

  const {
    feedbackQuestions,
    showFeedbackModal,
    currentFeedbackType,
    currentStep,
    setCurrentStep,
    feedbacks,
    updateFeedback,
    handleFeedbackSubmit,
    openModal,
    closeModal,
    nextStep,
    prevStep,
    skipFeedback
  } = feedbackModal

  const validationErrors = useMemo(() => {
    const errors = {}
    feedbackQuestions.forEach((question, index) => {
      const feedback = feedbacks[index]
      if (!feedback.score || feedback.score.trim() === '') {
        errors[index] = 'Score is required'
      } else {
        const scoreNum = parseFloat(feedback.score)
        if (isNaN(scoreNum) || scoreNum < 1 || scoreNum > 10) {
          errors[index] = 'Score must be a number between 1 and 10'
        }
      }
    })
    return errors
  }, [feedbacks, feedbackQuestions])

  const isValid = feedbacks.some(f => {
    const score = parseFloat(f.score)
    return !isNaN(score) && score >= 1 && score <= 10
  })

  const handleSubmit = () => {
    if (isValid) {
      handleFeedbackSubmit()
    }
  }

  const isStepValid = !validationErrors[currentStep]

  const handleOpenModal = (type) => {
    openModal(type)
  }

  return (
    <>
      <button
        className={styles.reviewButton}
        onClick={() => handleOpenModal(recommendationType)}
      >
        <FiMessageSquare className={styles.logoIcon} />
        {buttonText}
      </button>

      {showFeedbackModal && (
        <Modal
          title={
            <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
              Share feedback
            </div>
          }
          visible={showFeedbackModal}
          onCancel={closeModal}
          width={900}
          bodyStyle={{
            padding: '24px',
            borderRadius: '12px'
          }}
          style={{
            borderRadius: '12px'
          }}
          footer={
            <ModalFooter
              currentStep={currentStep}
              totalSteps={feedbackQuestions.length}
              isStepValid={isStepValid}
              isValid={isValid}
              onPrev={prevStep}
              onNext={nextStep}
              onSubmit={handleSubmit}
              onCancel={closeModal}
              onSkip={skipFeedback}
            />
          }
        >
          <div className={styles.modalDescription}>
            <p className={styles.modalDescriptionText}>
              Share your thoughts for the{' '}
              {getRecommendationDisplayName(currentFeedbackType).toLowerCase()}{' '}
              generated by AI
            </p>
          </div>
          <StepIndicator
            totalSteps={feedbackQuestions.length}
            currentStep={currentStep}
          />

          <FeedbackQuestionStep
            question={feedbackQuestions[currentStep]}
            feedback={feedbacks[currentStep]}
            validationError={validationErrors[currentStep]}
            onScoreChange={(value) =>
              updateFeedback(currentStep, 'score', value)
            }
            onCommentsChange={(value) =>
              updateFeedback(currentStep, 'comments', value)
            }
          />
        </Modal>
      )}
    </>
  )
}

export default FeedbackModal
